import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { POPULAR, RELEVANCE, SORT_ORDER } from './constants';

const DEFAULT_SEARCH = '';
const DEFAULT_FILTERS = [];
const DEFAULT_SORTBY = POPULAR.value;
const DEFAULT_PAGENUM = 0;
const DEFAULT_SORTORDER = SORT_ORDER.ascending;

const DEFAULT_SEARCH_PARAMS = {
  search: DEFAULT_SEARCH,
  filters: DEFAULT_FILTERS,
  sortBy: DEFAULT_SORTBY,
  sortOrder: DEFAULT_SORTORDER,
  pageNum: DEFAULT_PAGENUM,
};

const SearchContext = React.createContext(DEFAULT_SEARCH_PARAMS);

const SearchProvider = ({ children }) => {
  const [search, setSearch] = useState(DEFAULT_SEARCH);
  const [filters, setFilters] = useState(DEFAULT_FILTERS);
  const [sortBy, setSortBy] = useState(DEFAULT_SORTBY);
  const [sortOrder, setSortOrder] = useState(DEFAULT_SORTORDER);
  const [pageNum, setPageNum] = useState(DEFAULT_PAGENUM);
  const [searchParams, setSearchParams] = useState({ ...DEFAULT_SEARCH_PARAMS });

  const updateSearch = newSearch => {
    setSearch(newSearch);
    setSortBy(RELEVANCE.value);
    setSortOrder(SORT_ORDER.descending);
    setPageNum(DEFAULT_PAGENUM);
    setSearchParams({
      ...searchParams,
      search: newSearch,
      sortBy: RELEVANCE.value,
      sortOrder: SORT_ORDER.descending,
      pageNum: DEFAULT_PAGENUM,
    });
  };
  const updateFilter = filter => {
    setFilters(filter);
    setSortBy(RELEVANCE.value);
    setSortOrder(SORT_ORDER.descending);
    setPageNum(DEFAULT_PAGENUM);
    setSearchParams({
      ...searchParams,
      filters: filter,
      sortBy: RELEVANCE.value,
      sortOrder: SORT_ORDER.descending,
      pageNum: DEFAULT_PAGENUM,
    });
  };
  const updateSortBy = order => {
    setSortBy(order);
    const newSortOrder = order === RELEVANCE.value ? SORT_ORDER.descending : SORT_ORDER.ascending;
    setSortOrder(newSortOrder);
    setPageNum(DEFAULT_PAGENUM);

    setSearchParams({ ...searchParams, sortBy: order, sortOrder: newSortOrder, pageNum: DEFAULT_PAGENUM });
  };
  const updatePageNum = page => {
    setPageNum(page);
    setSearchParams({ ...searchParams, pageNum: page });
  };

  const resetSearch = () => {
    setSearch(DEFAULT_SEARCH);
    setFilters(DEFAULT_FILTERS);
    setSortBy(DEFAULT_SORTBY);
    setSortOrder(DEFAULT_SORTORDER);
    setPageNum(DEFAULT_PAGENUM);
    setSearchParams({ ...DEFAULT_SEARCH_PARAMS });
  };

  const hasSearchParams = () => {
    return search !== DEFAULT_SEARCH || filters !== DEFAULT_FILTERS;
  };

  useEffect(() => {
    const savedSearchParams = sessionStorage.getItem('searchParams');
    if (savedSearchParams) {
      const newSearchParams = JSON.parse(savedSearchParams);
      setSearchParams(newSearchParams);
      setSearch(newSearchParams.search);
      setFilters(newSearchParams.filters);
      setSortBy(newSearchParams.sortBy);
      setSortOrder(newSearchParams.sortOrder);
      setPageNum(newSearchParams.pageNum);
    }
  }, []);

  // Save to sessionStorage when searchParams changes
  useEffect(() => {
    sessionStorage.setItem('searchParams', JSON.stringify(searchParams));
  }, [searchParams]);

  return (
    <SearchContext.Provider
      value={{
        search,
        filters,
        sortBy,
        sortOrder,
        pageNum,
        updateSearch,
        updateFilter,
        updateSortBy,
        updatePageNum,
        resetSearch,
        hasSearchParams,
      }}
    >
      {children}
    </SearchContext.Provider>
  );
};

SearchProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

const SearchConsumer = SearchContext.Consumer;

export { SearchProvider, SearchConsumer, SearchContext };
